import styleText from './as-spinner.css?raw';

/**
 * Simple spinner component for loading states
 */
export class AsSpinner extends HTMLElement {
  static readonly tag = 'as-spinner' as const;

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsSpinner._sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <div class="spinner"></div>
    `;
  }
}

if (!customElements.get(AsSpinner.tag)) {
  customElements.define(AsSpinner.tag, AsSpinner);
} else {
  console.warn('as-spinner already defined');
}
